import FormView from 'containers/Customers/FormView'

export default FormView
